import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouteMap } from '@core/models/client';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private router = inject(Router);

  getCurrentUrl(): string | null {
    return location.pathname;
  }

  loadToLogin(): void {
    window.location.href = RouteMap.PUBLIC_LOGIN_INIT;
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  navigateToLogin() {
    this.router.navigate([RouteMap.PUBLIC_LOGIN_INIT]);
  }

  // navigateToSigninPassword(login: string) {
  //   this.router.navigate(['public/signin/password'], {
  //     state: {
  //       login,
  //     },
  //   });
  // }

  // navigateToSigninOtp(requestKey: string) {
  //   this.router.navigate(['public/signin/otp'], {
  //     state: {
  //       requestKey,
  //     },
  //   });
  // }

  // navigateToSignupTempPassword(requestKey: string) {
  //   this.router.navigate(['public/signup/temppassword'], {
  //     state: {
  //       requestKey,
  //     },
  //   });
  // }

  // navigateToSignupSetPassword(requestKey: string) {
  //   this.router.navigate(['public/signup/setpassword'], {
  //     state: {
  //       requestKey,
  //     },
  //   });
  // }

  // navigateToSignupOtp(requestKey: string) {
  //   this.router.navigate(['public/signup/otp'], {
  //     state: {
  //       requestKey,
  //     },
  //   });
  // }

  navigateToResetPassword() {
    this.router.navigate([RouteMap.PUBLIC_RESETPASSWORD_INIT]);
  }

  // navigateToResetPasswordOtp(requestKey: string) {
  //   this.router.navigate(['public/resetpassword/otp'], {
  //     state: {
  //       requestKey,
  //     },
  //   });
  // }

  navigateToResetPasswordSetPassword() {
    this.router.navigate([RouteMap.PUBLIC_RESETPASSWORD_SETPASSWORD]);
  }

  navigateToReportAbonaments(): void {
    this.router.navigate([RouteMap.PRIVATE_REPORTABONAMENTS]);
  }
}
